"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var base_1 = require("./base");
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reservedAttr = ["x", "y", "text-anchor"];
        _this._computedTextSize = {};
        return _this;
    }
    Text.attributeForTagContent = function () {
        return "_text";
    };
    Text.prototype.computeIntrinsicSize = function () {
        var _this = this;
        if (this.noNeedToRender) {
            return;
        }
        var prop = this._isDirty("_html") ? "html" :
            this._isDirty("_text") ? "text" : null;
        this.dom.each(function (d, i, g) {
            var node = d3.select(g[i]);
            var contentSize = { width: 50, height: 12 };
            if (prop) {
                var text = _this.getOption("_" + prop, d, i, g);
                if (_this._computedTextSize[text]) {
                    contentSize = _this._computedTextSize[text];
                }
                else {
                    node[prop].call(node, text);
                    try {
                        var bbox = g[i].getBBox();
                        contentSize.width = bbox.width;
                        contentSize.height = bbox.height;
                    }
                    catch (e) { /* do nothing */ }
                    _this._computedTextSize[text] = contentSize;
                }
            }
            _this._intrinsicSize[i] = contentSize;
        });
        // super
        _super.prototype.computeIntrinsicSize.call(this);
    };
    Text.prototype.renderElement = function (node, d, i, g, h) {
        if (this._isDirty("_html")) {
            node.html(h.op("_html"));
        }
        else if (this._isDirty("_text")) {
            node.text(h.op("_text"));
        }
        var pos = {
            x: this._getGeometry("_x", true, d, i, g),
            y: this._getGeometry("_y", false, d, i, g),
        };
        var y;
        var textAnchor;
        var bBoxHeight = 12;
        try {
            bBoxHeight = g[i].getBBox().height;
        }
        catch (e) {
            // do nothing
        }
        var anchor = h.op("_anchor");
        if (anchor & 16 /* Left */) {
            textAnchor = "start";
        }
        else if (anchor & 32 /* Center */) {
            textAnchor = "middle";
        }
        else if (anchor & 64 /* Right */) {
            textAnchor = "end";
        }
        if (anchor & 2 /* Top */) {
            y = pos.y + bBoxHeight;
        }
        else if (anchor & 4 /* Middle */) {
            y = pos.y + bBoxHeight / 2;
        }
        else if (anchor & 8 /* Bottom */) {
            y = pos.y;
        }
        node.attr("x", pos.x)
            .attr("y", y)
            .attr("text-anchor", textAnchor);
    };
    Text.prototype.text = function (txt) {
        this._options._text = txt;
        return this;
    };
    Text.nodeName = "text";
    return Text;
}(base_1.BaseElement));
exports.Text = Text;
//# sourceMappingURL=text.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/text.js
// module id = 1137
// module chunks = 0 1